import { useEffect, useCallback } from 'react';

const SubscribeListeners = ({ eventEmitter, applyStoreAction }) => {
    const userSubscribed = useCallback(({ association_id }) => {
        applyStoreAction({
            type: 'SUBSCRIBE_SOCKET',
            payload: { association_id }
        });
    }, [applyStoreAction]);

    const userUnsubscribed = useCallback(({ association_id }) => {
        applyStoreAction({
            type: 'UNSUBSCRIBE_SOCKET',
            payload: { association_id }
        });
    }, [applyStoreAction]);

    const listen = () => {
        eventEmitter.on('user_subscribed', userSubscribed);
        eventEmitter.on('user_unsubscribed', userUnsubscribed);

        return () => {
            eventEmitter.off('user_subscribed', userSubscribed);
            eventEmitter.off('user_unsubscribed', userUnsubscribed);
        };
    };

    useEffect(listen, [eventEmitter, userSubscribed, userUnsubscribed]);

    return null;
}

export default SubscribeListeners;
